import { render, staticRenderFns } from "./userRoleForm.vue?vue&type=template&id=cf4a738c&scoped=true"
import script from "./userRoleForm.vue?vue&type=script&lang=js"
export * from "./userRoleForm.vue?vue&type=script&lang=js"
import style0 from "./userRoleForm.vue?vue&type=style&index=0&id=cf4a738c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4a738c",
  null
  
)

export default component.exports